<template>
  <div class="videoLiveing">
      <div class="videoLiveing-main">
          <AsideButton :detailsList="detailsList" v-if="dataStatus"></AsideButton>
          <!-- 视频直播 侧边状态按钮 -->
          <VideoHeadText :detailsList="detailsList" v-if="dataStatus"></VideoHeadText>
          <!-- 视频直播 顶部标题文本 -->
          <div class="flex-start flex-top">
              <div class="left">
                  <VideoImgAndVideoFansAndComment :detailsList="detailsList" v-if="dataStatus"></VideoImgAndVideoFansAndComment>
                  <div class="">
                      <div class="video-menu" v-if="detailsList.contentlist.length > 0" >
                          <div class="video-menu-content" v-if="detailsList.contentlist.length > 1 || (detailsList.contentlist.length === 1 && detailsList.contentlist[0].columntype !== 5)">
                              <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                                  <template v-for="(item, index) in detailsList.contentlist">
                                      <el-menu-item :key="index" :index="(index + 1).toString()" :disabled="item.columntype === 99" v-if="item.columntype !== 5">
                                          <div @click="clickLinkurl(item)">{{item.columnname}}</div></el-menu-item>
                                  </template>
                                  <!-- <el-menu-item index="2">分段视频</el-menu-item> -->
                                  <!-- <el-menu-item index="3">邀请嘉宾</el-menu-item> -->
                              </el-menu>
                              <div class="menu-all-list">
                                  <div v-for="(item, index) in detailsList.contentlist" :key="index">
                                      <ImageAndTextListCard v-show="activeIndex == (index + 1) && item.columntype == 1" :item="item"></ImageAndTextListCard>
                                      <!-- end 图文模块 -->
                                      <VideoListCard v-show="activeIndex == (index + 1) && item.columntype == 2" :item="item"></VideoListCard>
                                      <!-- end 视频集合模块 -->
                                      <AlbumListCard v-show="activeIndex == (index + 1) && item.columntype == 3"  :item="item"></AlbumListCard>
                                      <!-- end 相册模块 -->
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="right">
                  <liveComment :detailsList="detailsList" v-if="dataStatus"></liveComment>
                  <VideoRecommend></VideoRecommend>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import $ from 'jquery'
import AsideButton from './components/AsideButton'
import VideoHeadText from './components/VideoHeadText'
import ImageAndTextListCard from './components/ImageAndTextListCard'
import VideoListCard from './components/VideoListCard'
import AlbumListCard from './components/AlbumListCard'
import VideoImgAndVideoFansAndComment from './components/VideoImgAndVideoFansAndComment'
import LiveComment from './components/liveComment'
import VideoRecommend from './components/VideoRecommend'
import {mapActions, mapGetters} from 'vuex'
import { getAliveProductDetail } from 'api/pcvideo.js'
export default {
  metaInfo() {
      return {
          meta: [
              {
                  name: "keywords",
                  content: this.keywords
              },                
              {
                  name: "description",
                  content: this.description
              }
          ]
      }
  },
  name: 'videoLiveing',
  data () {
    return {
      activeIndex: '1', // 默认菜单
      objectid: this.$route.query.innerid,  // 内容ID
      detailsList: {contentlist: []}, // 详情集合
      dataStatus: false, // 取得数据状态
      keywords: '',
      description: ''
    }
  },
  created() {
    if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MliveDetails',
                query: {liveid: this.$route.query.innerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}
            })
        }
  },
  mounted () {
    $('body').css('background', '#f8f8f8')
    this.initDetails()
  },
  destroyed () {
    $('body').css('background', '#fff')
  },
  methods: {
    initDetails() { // 初始化详情
      this.setLoading(true)
      getAliveProductDetail({
        data: {objectid: this.objectid, channelid: this.$route.query.chid ? this.$route.query.chid : ''},
        success: data => {
          this.setLoading(false)
          // data.data.streamstatus = 1
          this.detailsList = data.data
          data.data.contentlist.some((item, index) => {
            if (item.columntype !== 99) {
                this.activeIndex = index + 1 + ''
                return true
            }
          })
          this.dataStatus = true
          document.title=this.detailsList.objectname + '-' + '精品直播'
          this.keywords = this.detailsList.objectname + ',' + this.detailsList.tags + ',鲸融网,精品直播'
          this.description = this.detailsList.description
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
    },
    clickLinkurl(item) {
      if (item.columntype === 99) {
        window.open(item.linkurl)
      }
      console.log(item)
    },
    handleSelect(tag) { // 点击切换菜单栏
      if (this.detailsList.contentlist[Number(tag)].columntype !== 99) {
        this.activeIndex = tag
      }
      console.log(tag, this.activeIndex)
    },
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {
    userstatus() {
      // 登录状态发生变化
      if (this.user) {
        // 刷新页面
        this.initDetails()
      }
    },
    'activeIndex': {
      handler(newV, oldV) {
        console.log(newV, oldV)
      }
    }
  },
  computed: {
    userstatus() {
      return this.user
    },
    ...mapGetters(['user', 'domainInfo'])
  },
  components: {
    AsideButton,
    VideoHeadText,
    ImageAndTextListCard,
    VideoListCard,
    AlbumListCard,
    VideoImgAndVideoFansAndComment,
    VideoRecommend,
    LiveComment
  }
}
</script>
<style lang="scss">
.videoLiveing {
  .el-menu--horizontal>.el-menu-item {
    height: 30px;
    line-height: 20px;
    margin-right: 40px;
    color: #333;
    font-size: 16px;
  }
}
</style>
<style lang="scss" type="text/scss" scoped>
.videoLiveing {
  margin-top: 24px;
  margin-bottom: 30px;
    .videoLiveing-main {
      display: block;
      margin: auto;
      width: 1180px;
    }
    .video-menu {
      float: left;
      width:860px;
      border-radius:16px;
      overflow: hidden;
      .menu-all-list {
        margin-top: 24px;
      }
      .video-menu-content {
        padding: 20px;
        box-sizing: border-box;
        background: #fff;
        .el-menu-demo {
          .el-menu-item.is-disabled {
            opacity: 1;
            cursor: pointer;
          }
        }
      } 
      .el-menu--horizontal>.el-menu-item.is-active {
        color: #409EFF;
      }
      .el-menu.el-menu--horizontal {
        border: none;
      }
    }
    .video-menu-details {
      margin-top: 30px;
    }
}
</style>